import { render, staticRenderFns } from "./goodsOrder-edit.vue?vue&type=template&id=687e460b&scoped=true&"
import script from "./goodsOrder-edit.vue?vue&type=script&lang=js&"
export * from "./goodsOrder-edit.vue?vue&type=script&lang=js&"
import style0 from "./goodsOrder-edit.vue?vue&type=style&index=0&id=687e460b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687e460b",
  null
  
)

export default component.exports